import React, { useState, useEffect } from "react";
import { GetLightpointData } from "../hooks/middleware.js";

export default function Header({ id }) {
  const { data, error } = GetLightpointData(id);
  const [title, setTitle] = useState("Projekt Stadtteil");

  useEffect(() => {
    if (data && data.length > 0) {
      const counts = data.reduce((acc, row) => {
        const district = row.properties.locationdistrict || "unknown";
        acc[district] = (acc[district] || 0) + 1;
        return acc;
      }, {});

      const sortedCounts = Object.entries(counts)
        .sort((a, b) => b[1] - a[1])
        .map(([district, count]) => ({ district, count }));

      const topDistricts = sortedCounts.slice(0, 5);

      if (topDistricts.length > 0) {
        if (topDistricts.length > 1) {
        setTitle(`Projekt ${topDistricts[0].district} und andere Stadtteile`);
      } else {
        setTitle(`Projekt ${topDistricts[0].district}`);
      }
      }
    }
  }, [data]);

  if (error) return <p>Error loading data.</p>;
  if (!data) return <p>Loading Header...</p>;
  if (data.length === 0) return <p>No data found</p>;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem 1.5rem",
      }}
    >
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={{
          fontSize: "1.5rem",
          fontWeight: "bold",
          color: "#555",
          textAlign: "left",
          border: "2px solid red",
          borderRadius: "6px",
          padding: "4px 8px",
          outline: "none",
          backgroundColor: "white",
          flex: 1,
          marginRight: "1rem",
        }}
      />
      <img
        src="/images/logo_hanau.jpg"
        alt="Logo"
        style={{ height: "50px", objectFit: "contain" }}
      />
    </div>
  );
}
